export default "__VITE_ASSET__DOZjLZf1__"